import { confirmRefund } from 'app/src/msw/refund/api/confirmRefund'
import { deleteRefund } from 'app/src/msw/refund/api/deleteRefund'
import { getRefund } from 'app/src/msw/refund/api/getRefund'
import { getRefunds } from 'app/src/msw/refund/api/getRefunds'

export const refundHandlers = [getRefunds, getRefund, deleteRefund, confirmRefund]
